<template>
    <div class="truncated-text" :class="`truncated-text-${locale}`">
        <ElementsRichContentWidgets v-if="richContentWidgets.length > 0" :widgets="richContentWidgets" :item-list-name="itemListName" />
        <template v-else>
            <div v-if="fullTextShown" class="truncated-text__fulldesc" v-html="fullText"></div>
            <div v-else class="truncated-text__shortdesc" v-html="truncatedText"></div>
            <template v-if="!showFullText && fullText.length > truncatedText.length + 1">
                <a
                    v-if="showMoreScrollToElement"
                    :href="`#${showMoreScrollToElement}`"
                    class="truncated-text__link"
                    @click.prevent="scrollToElement(showMoreScrollToElement)"
                    >{{ $t('showText') }}</a
                >
                <a v-else href="#" class="truncated-text__link" @click.prevent="showFullTextClicked">
                    {{ $t(buttonText) }}
                </a>
            </template>
        </template>

        <div v-if="!showMoreScrollToElement && fullText && !showFullText" class="d-none" v-html="fullText" />
    </div>
</template>
<script lang="ts">
// import truncate from 'truncate-html'
import clip from 'text-clipper'
import { PropType } from 'vue'
import DataLayer from '~/extensions/DataLayer'
import Widget from '~/models/StaticContent/Widget'

export default {
    props: {
        text: {
            type: String,
            default: '',
        },
        seoPerex: {
            type: String,
            default: '',
        },
        limit: {
            type: Number,
            default: null,
        },
        limitDesktop: {
            type: Number,
            default: null,
        },
        isDesktop: {
            type: Boolean,
            default: true,
        },
        richContentWidgets: {
            type: Array as PropType<Widget[]>,
            default: () => [],
        },
        itemListName: {
            type: String,
            default: '',
        },
        showFullText: {
            type: Boolean,
            default: false,
        },
        showMoreScrollToElement: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            fullTextShown: this.showFullText,
            buttonText: this.showFullText ? 'hideText' : 'showText',
            clearText: this.text.replace(/(<([^>]+)>)/gi, ''),
        }
    },

    computed: {
        locale() {
            return useRuntimeConfig().public.locale
        },

        truncatedText() {
            const showMorePosition = this.fullText.indexOf('<!--more-->')
            if (showMorePosition >= 0) {
                return this.fullText.substring(0, showMorePosition)
            }

            // @ts-ignore
            const truncateFunction = clip.default || clip
            if (this.isDesktop) {
                return truncateFunction(this.fullText, this.limitDesktop, { html: true })
            } else {
                return truncateFunction(this.fullText, this.limit, { html: true })
            }
        },

        fullText() {
            return this.text + '<p>' + this.seoPerex + '</p>'
        },
    },

    methods: {
        scrollToElement(elementId: string) {
            const scrollElement = document.getElementById(elementId)
            if (scrollElement) {
                const scrollTo = scrollElement.getBoundingClientRect().top + window.scrollY
                window.scroll({ top: scrollTo, behavior: 'smooth' })
            }
        },

        showFullTextClicked() {
            this.buttonText = !this.fullTextShown ? 'hideText' : 'showText'

            setTimeout(() => {
                this.fullTextShown = !this.fullTextShown

                if (this.fullTextShown) {
                    DataLayer.push({
                        event: 'show_more',
                        show_more_url: location.href,
                        show_more_count: 1,
                    })
                }
            }, 0)

            // FIXME CG v brand.vue
            setTimeout(function () {
                ;[...document.querySelectorAll('.lazyload')].forEach(function (item) {
                    if (item.getAttribute('data-src') !== null) {
                        item.setAttribute('src', item.getAttribute('data-src') || '')
                    }
                })
            }, 500)
        },
    },
}
</script>

<style lang="scss" scoped>
.truncated-text {
    margin-bottom: 11px;
    max-width: 100%;
}

.truncated-text__link {
    font-size: 16px;
    display: inline-block;
    padding: 0 5px;
    font-weight: 700;
}

.truncated-text__fulldesc,
.truncated-text__shortdesc {
    display: inline;

    &:deep(p) {
        font-size: 16px;
        line-height: 24px;
        margin: 0 0 10px 0;
    }

    &:deep(h2) {
        margin-bottom: 0.7rem;
        margin-top: 1.8rem;
        font-size: 22px;
    }

    &:deep(h3) {
        margin-bottom: 0.7rem;
        margin-top: 1.8rem;
        font-size: 20px;
    }

    &:deep(ul) {
        margin: 0;
        list-style-type: none;
        padding-left: 2rem;
        font-weight: 400;

        li {
            font-size: 16px;
            line-height: 24px;
            font-style: normal;
            list-style: none;
            position: relative;
            padding: 0;

            &:before {
                background: $color-purple;
                border: 0;
                border-radius: 50%;
                content: '';
                height: 8px;
                left: -20px;
                position: absolute;
                top: 8px;
                width: 8px;
            }
        }
    }
}

.truncated-text__shortdesc:deep(p) {
    display: inline;
}

/*.truncated-text-cz {
    &:deep(img) {
        display: none;
    }

    &:deep(.carouselBox img) {
        display: block;
    }
}*/
</style>
